export enum TooltipVariant {
  FullWidth = 'fullWidth',
  Icon = 'icon',
}
